<template>
  <v-dialog v-model="model" max-width="500px">
    <v-card>
      <v-card-title class="modal-chat__title">
        <span>{{ modalTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout v-if="action === 'edit' && selectedCode" wrap>
            <v-flex xs12 sm6 md12>
              <v-text-field :value="formDateTimeSec(selectedCode.created_at)" label="Дата | Время" disabled />
            </v-flex>
            <v-flex xs12 sm6 md12>
              <v-text-field
                v-model="selectedCode.name"
                color="accent"
                :rules="[v => !!v || 'Поле обязательно для заполнения']"
                label="Название промокода"
              />
            </v-flex>
            <v-flex xs12 sm6 md12>
              <v-text-field
                v-model="selectedCode.code"
                v-mask="'XXXX XXXX XXXX'"
                color="accent"
                type="text"
                placeholder="ХХХХ ХХХХ ХХХХ"
                label="Промокод"
              />
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="selectedCode.prize"
                color="accent"
                type="number"
                :rules="numValidation"
                label="Сумма промокода"
              />
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="selectedCode.activations_max_count"
                color="accent"
                type="number"
                :rules="numValidation"
                label="Max кол-во активаций"
              />
            </v-flex>
          </v-layout>
          <v-layout v-if="action === 'create'" wrap>
            <v-flex xs12 sm6 md12>
              <v-text-field
                ref="nameInput"
                v-model="newCode.name"
                :rules="[v => !!v || 'Поле обязательно для заполнения']"
                color="accent"
                label="Название промокода"
              />
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="newCode.code"
                v-mask="'XXXX XXXX XXXX'"
                type="text"
                color="accent"
                placeholder="ХХХХ ХХХХ ХХХХ"
                label="Промокод"
              />
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-btn text @click="randCode(12)">Сгенерировать</v-btn>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="newCode.prize"
                color="accent"
                type="number"
                label="Сумма промокода"
                :rules="numValidation"
              />
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="newCode.activations_max_count"
                color="accent"
                type="number"
                :rules="numValidation"
                label="Max кол-во активаций"
              />
            </v-flex>
          </v-layout>
          <v-flex
            v-if="action === 'delete' && selectedCode"
            class="modal-chat__confirm"
            xs12
            sm6
            md12
          >
            Вы уверены, что хотите удалить промокод?
          </v-flex>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close">Отмена</v-btn>
        <v-btn v-if="action === 'create'" text @click="addPromoCode">Добавить</v-btn>
        <v-btn v-if="action === 'edit'" text @click="changePromoCode">Сохранить</v-btn>
        <v-btn v-if="action === 'delete'" text @click="deletePromoCode">Удалить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import { baseURL } from '../../api/config'
import VueMixin from '../VueMixin.vue'

export default {
  name: 'MessageModal',
  mixins: [VueMixin],
  props: ['selectedItem', 'modalTitle', 'action', 'showModal'],
  data: () => ({
    model: false,
    newCode: {
      name: '',
      code: '',
      prize: '',
      activations_max_count: ''
    },
    numValidation: [
      v => (v === '' || !isNaN(Number(v))) || 'Введите число',
      v => (v === '' || Number(v) > 0) || 'Число должно быть положительным'
    ],
    selectedCode: null,
    blockTime: 0,
    alertText: ''
  }),
  watch: {
    model (newVal) {
      if (!newVal) this.$emit('close')
    },
    showModal () {
      this.model = this.showModal
      if (!this.model) this.$refs.nameInput.resetValidation()
      if (this.action === 'create')
        this.selectedCode = null
      else
        this.selectedCode = { ...this.selectedItem }
    },
    selectedItem () {
      this.selectedCode = { ...this.selectedItem }
    }
  },
  mounted () {
    this.model = this.showModal
  },
  methods: {
    close () {
      this.$emit('close')
      this.selectedCode = null
    },
    randCode (n) {
      let text = ''
      const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

      for (let i = 0; i < n; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length))

      this.newCode.code = text
    },
    addPromoCode () {
      const code = this.newCode.code.replace(/\s+/g, '')
      const url = `${baseURL}/promo-codes`
      axios
        .post(url, {
          name: this.newCode.name,
          code,
          prize: this.newCode.prize,
          activations_max_count: this.newCode.activations_max_count
        })
        .then(response => {
          this.alertText = 'Промокод успешно добавлен!'
          EventBus.$emit('code-emit', this.alertText)
          this.close()
        })
        .catch(error => {
          this.alertText = error.response.data.message
          EventBus.$emit('code-emit', { alertText: this.alertText, isSuccess: false })
          console.error(error)
        })
    },
    deletePromoCode () {
      const url = `${baseURL}/promo-codes/${this.selectedCode.id}`
      axios
        .delete(url)
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          this.alertText = 'Промокод успешно удален!'
          EventBus.$emit('code-emit', this.alertText)
          this.close()
        })
    },
    changePromoCode () {
      const code = this.selectedCode.code.replace(/\s+/g, '')
      const url = `${baseURL}/promo-codes/${this.selectedCode.id}`
      axios
        .put(url, {
          name: this.selectedCode.name,
          code,
          prize: this.selectedCode.prize,
          activations_max_count: this.selectedCode.activations_max_count
        })
        .then(response => {
          this.alertText = 'Промокод отредактирован успешно!'
          EventBus.$emit('code-emit', { alertText: this.alertText })
          this.close()
        })
        .catch(error => {
          this.alertText = error.response.data.message
          EventBus.$emit('code-emit', { alertText: this.alertText, isSuccess: false })
          console.error(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.flex.md6 {
  .theme--light {
    width: 100%;
  }
}
</style>
